module.exports = __webpack_public_path__ + "dc6b85478ceecdf7a38bc86e89479d76.pdf";